import {SingleSelectPicker} from '@github-ui/filter-picker'

import {getReposItemConfig} from './ItemConfig'
import {SingleSelectReposPickerDialog} from './SingleSelectReposPickerDialog'
import type {SingleSelectReposProps} from './types'

export function SingleSelectReposPicker(props: SingleSelectReposProps) {
  const {isOpenInitially, ['aria-describedby']: ariaDescribedby, ...dialogProps} = props
  const itemConfig = getReposItemConfig(dialogProps.scope)

  return (
    <SingleSelectPicker
      aria-describedby={ariaDescribedby}
      isOpenInitially={isOpenInitially}
      itemConfig={itemConfig}
      selected={dialogProps.selected}
      renderDialog={publicProps => <SingleSelectReposPickerDialog {...publicProps} {...dialogProps} />}
    />
  )
}

try{ SingleSelectReposPicker.displayName ||= 'SingleSelectReposPicker' } catch {}